import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { object, array, string } from "prop-types";
import { Link } from "@quintype/components";

import { MenuItem } from "../menu-item";
import { AppLogo } from "../app-logo";
import { SOCIAL_LINKS } from "../../../constants";
import { getLinkTarget } from "../../../arrow/utils/utils";

import "./footer.m.css";

const MenuGroup = ({ menus }) => {
  return menus.map(
    ({ title, children }, id) =>
      children &&
      children.length > 0 && (
        <div styleName="menu-group" key={id}>
          <h6 styleName="title footer-text">{title}</h6>
          <ul styleName="menu-list">
            {children &&
              children.map((item, id) => (
                <li styleName="list-item footer-text" key={id}>
                  <MenuItem item={item} menuStyle="menu-items-footer" />
                </li>
              ))}
          </ul>
        </div>
      )
  );
};

const SocialIcons = ({ socialLinks = [] }) => {
  return (
    <div styleName="social-icons">
      {SOCIAL_LINKS.map(({ type, urlKey, icon: IconComponent }) => (
        socialLinks[urlKey] && <Link key={type} href={socialLinks[urlKey]} aria-label={`Visit our ${type} page`} styleName="social-link" target={getLinkTarget(socialLinks[urlKey])} rel="noopener">
          <IconComponent color="var(--malibu-gray9)" width={24} height={24} />
        </Link>
      ))}
    </div>
  );
};

const FooterBase = ({ menu, socialLinks, footerStaticMenu, publisherSettings, className = "", styleClass }) => {
  const { copyright, "publisher-logo": publisherLogo } = publisherSettings || {};
  const footerMenus = menu.filter(item => item["item-type"] === "placeholder");
  return (
    <div>
      <div styleName={`footer ${className} ${styleClass}`}>
        <div styleName="footer-top">
          <div styleName="logo-section">
            <AppLogo width={72} height={36} imgSrc={publisherLogo?.url} styleName="footer-logo" />
            <SocialIcons socialLinks={socialLinks} />
          </div>
          <div styleName="menu-section">
            <MenuGroup menus={footerMenus} />
          </div>
        </div>
        <div styleName="footer-bottom">
          <div styleName="legal-links">
            {footerStaticMenu && footerStaticMenu.map((item, index) => (
              <Link key={index} href={item.url} styleName="legal-link footer-text" target={getLinkTarget(item.url)} rel="noopener">{item.title}</Link>
            ))}
          </div>
          <div styleName="footer-text">
            {copyright ? copyright : "© iMA-india 2025. All rights Reserved."}
          </div>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  const storyTemplate = get(state, ["qt", "data", "story", "story-template"], "");
  const collectionName = get(state, ["qt", "data", "collection", "name"], "");
  const isLeadershipFocus = storyTemplate === "leadership-in-focus" || collectionName === "Leadership In Focus";

  return {
    styleClass: isLeadershipFocus ? "no-top-margin-border" : "",
    menu: get(state, ["qt", "data", "navigationMenu", "footer"], []),
    footerStaticMenu: get(state, ["qt", "data", "navigationMenu", "footerStatic"], []),
    socialLinks: get(state, ["qt", "config", "social-links"], []),
    publisherSettings: get(state, ["qt", "config", "publisher-settings"], {})
  };
}

SocialIcons.propTypes = {
  socialLinks: array
};

FooterBase.propTypes = {
  menu: object,
  socialLinks: array,
  className: string,
  styleClass: string,
};

export const Footer = connect(mapStateToProps, null)(FooterBase);
